module.exports = __webpack_public_path__ + "24cd2d95207914ca60cfb8e34e1e66d3.svg";